import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Recherche from '../views/Recherche.vue'
import Favoris from '../views/Favoris.vue'
import Register from '../views/Register.vue'
import Login from '../views/Login.vue'
import UserPanel from '../views/UserPanel.vue'
import Jeu from '../components/Jeu.vue'
import Categories from '../views/Categories.vue'
import Categorie from '../components/Categorie.vue'
import AdminConnection from '../views/AdminConnection.vue'
import AdminPanel from '../views/AdminPanel.vue'
import AdminAddGame from '../views/AdminAddGame.vue'
import AdminEditGames from '../views/AdminEditGames.vue'
import AdminEditGame from '../views/AdminEditGame.vue'
import AdminFeatureGames from '../views/AdminFeatureGames.vue'
import AdminFeatureGame from '../views/AdminFeatureGame.vue'
import AdminEditSlider from '../views/AdminEditSlider.vue'
import AdminEditSlide from '../views/AdminEditSlide.vue'
import AdminEditComments from '../views/AdminEditComments.vue'
import AdminAddAccount from '../views/AdminAddAccount.vue'
import AdminEditAccounts from '../views/AdminEditAccounts.vue'
import AdminEditAccount from '../views/AdminEditAccount.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/recherche/:search', name: 'recherche', component: Recherche },
  { path: '/favoris', component: Favoris },
  { path: '/register', component: Register },
  { path: '/login', name: 'login', component: Login },
  { path: '/me', name: 'userPanel', component: UserPanel },
  { path: '/:gameTitle', component: Jeu },
  { path: '/categories', component: Categories },
  { path: '/categorie/:categoryName', component: Categorie },
  { path: '/categorie', redirect: '/categories' },
  { path: '/private170621/administration', name: 'adminConnection', component: AdminConnection },
  { path: '/private170621/administration/panel', name: 'adminPanel', component: AdminPanel },
  { path: '/private170621/administration/addGame', name: 'adminAddGame', component: AdminAddGame },
  { path: '/private170621/administration/editGames', name: 'adminEditGames', component: AdminEditGames },
  { path: '/private170621/administration/editGame/:gameTitle', name: 'adminEditGame', component: AdminEditGame },
  { path: '/private170621/administration/featureGames', name: 'adminFeatureGames', component: AdminFeatureGames },
  { path: '/private170621/administration/featureGame/:gameId', name: 'adminFeatureGame', component: AdminFeatureGame },
  { path: '/private170621/administration/editSlider', name: 'adminEditSlider', component: AdminEditSlider },
  { path: '/private170621/administration/editSlide/:slideId', name: 'adminEditSlide', component: AdminEditSlide },
  { path: '/private170621/administration/editComments', name: 'adminEditComments', component: AdminEditComments },
  { path: '/private170621/administration/addAccount', name: 'adminAddAccount', component: AdminAddAccount },
  { path: '/private170621/administration/editAccounts', name: 'adminEditAccounts', component: AdminEditAccounts },
  { path: '/private170621/administration/editAccount/:accountId', name: 'adminEditAccount', component: AdminEditAccount },
  { path: '/:pathMatch(.*)', redirect: '/' }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
